// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xShgZ","large":"styles_large__a7uxr","info":"styles_info__HnXFr"};